import React from 'react';
import { useAppDispatch } from 'ducks/hooks';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

import { useTestFeature } from 'optimizely/hooks';
import { getSelectedGroupId, selectGroup } from 'ducks/products';
import Box from 'ui/Box';
import MobileDrawer from 'components/MobileDrawer/MobileDrawer';
import { isAutoFillSheetVisible, setAutofillActive, setAutoFillSheetVisible } from '../AutofillPax';
import AutoFillOptimizeSpacePax from '../widgets/AutoFillOptimizeSpacePax';
import { useBehaviorTracker } from 'contexts/behaviors';

const AutoFillMenuWrapper = styled.div`
  overflow-y: auto;
  height: 100%;
`;

const AutoFillSheetMobile = () => {
  const dispatch = useAppDispatch();
  const autoFillSheetVisible = useSelector(isAutoFillSheetVisible);
  const { formatMessage } = useIntl();
  const autofillMobileTestEnabled = useTestFeature('PaxAutofillMobile');
  const selectedGroupId = useSelector(getSelectedGroupId);
  const behaviorTracker = useBehaviorTracker();

  const onClose = () => {
    behaviorTracker
      .withContext({
        groupId: selectedGroupId,
        menuType: 'sheet',
        widgetId: 'autofill-pax-sheet-mobile'
      })
      .custom(() => {
        dispatch(setAutoFillSheetVisible(false));
        dispatch(setAutofillActive(false));
        dispatch(selectGroup(''));
      });
  };

  return autofillMobileTestEnabled && autoFillSheetVisible ? (
    <MobileDrawer
      open={autoFillSheetVisible}
      onDismiss={onClose}
      title={formatMessage({ id: 'storageone.autofillPaxLSheetTitle' })}
    >
      <AutoFillMenuWrapper>
        <Box margin="md" style={{ marginTop: 0 }}>
          <AutoFillOptimizeSpacePax />
        </Box>
      </AutoFillMenuWrapper>
    </MobileDrawer>
  ) : (
    <></>
  );
};

export default AutoFillSheetMobile;
